export const popupModalCssFiles = {
  unbundled: {
    dev: [
      "public/css/2014/stylesheets/global.css",
      "public/css/2014/stylesheets/fonts/font-awesome/css/all.css",
      "public/css/2014/stylesheets/popup-modal/popup-modal.css",
      "public/css/emoji.css",
      "public/css/tooltipster.css",
      "public/css/tooltipster.custom.css",
      "public/css/flickity-2_0_4.min.css"
    ]
  },
  bundled: {
    dev: ["public/css/build/dev/popup-modal.css"],
    prod: ["public/css/build/prod/popup-modal.min.css"]
  }
};
